// This component takes a list of relevant users to choose from and an array of
// html form namespaces so that the params sent to the server can be structured
// as needed via hidden inputs.
import React, { useState, useEffect } from "react";
import DefaultAvatar from "utils/DefaultAvatar";
import CustomAvatar from "utils/CustomAvatar";
import { Row, Col, Form, Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function UserSelector(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const fieldsFor = props.fieldsForArray.map((field) => `[${field}]`).join("") + "[]";
  const [selectedUsers, setSelectedUsers] = useState(Array.isArray(props.defaultValue) ? props.defaultValue : []);
  const [toggledUsers, setToggledUsers] = useState([]);
  const unSelectedUsers = Object.keys(props.users).filter((userEmail) => !selectedUsers.includes(userEmail));
  const [visibleUsers, setVisibleUsers] = useState([...unSelectedUsers]);
  // Update the list of users you can select from to be only unselected ones
  useEffect(() => {
    setVisibleUsers([...Object.keys(props.users).filter((userEmail) => !selectedUsers.includes(userEmail))]);
  }, [selectedUsers]);

  // Update the list of selected users
  useEffect(() => {
    setSelectedUsers(Array.isArray(props.defaultValue) ? props.defaultValue : []);
  }, [props.defaultValue]);

  const toggleUser = (e) => {
    let userEmail = e.target.getAttribute("data-email");
    let selection = [...toggledUsers];
    if (selection.includes(userEmail)) {
      selection.splice(selection.indexOf(userEmail), 1);
    } else {
      selection.push(userEmail);
    }
    setToggledUsers(selection);
  };

  const selectUsers = () => {
    props.setServiceAccount && props.setServiceAccount([...selectedUsers, ...toggledUsers]);
    setSelectedUsers([...selectedUsers, ...toggledUsers]);
    setToggledUsers([]);
    handleClose();
  };

  const unselectUser = (e) => {
    let userEmail = e.target.getAttribute("data-email");
    let selection = [...selectedUsers];
    selection.splice(selection.indexOf(userEmail), 1);
    props.setServiceAccount && props.setServiceAccount(selection);
    setSelectedUsers(selection);
    props.validator()
  };

  const handleCancel = () => {
    setToggledUsers([]);
    handleClose();
  };

  const searchUsers = (e) => {
    let filter = e.target.value.toLowerCase();
    let matchedUsers = [];
    Object.keys(props.users).forEach((userEmail) => {
      let user = props.users[userEmail];
      // If the user is not subscribed already && their name or email matches input
      if (!selectedUsers.includes(userEmail) && (user.name.toLowerCase().includes(filter) || userEmail.toLowerCase().includes(filter))) {
        matchedUsers.push(userEmail);
      }
    });
    setVisibleUsers(matchedUsers);
  };

  const toggledUsersList = toggledUsers.map((userEmail) => {
    let user = props.users[userEmail];
    return (
      <span key={user.id} data-email={userEmail} onClick={(e) => toggleUser(e)}>
        {user.name}
        <i style={{ pointerEvents: "none" }} className="fa fa-times"></i>
      </span>
    );
  });
  const btnDisabled = props.isEnabled !== undefined ? !props.isEnabled : false;
  return (
    <>
      <div className={`select-users ${props.bigAvatars ? "big-avatars" : ""}`}>
        {selectedUsers.map((userEmail, index) => {
          let user = props.users[userEmail];
          if (user) {
            let avatar = <DefaultAvatar dim={props.bigAvatars ? "70x70" : "32x32"} name={user.name} className="avatar" department={user.department} />;
            if (user.avatar) {
              avatar = <CustomAvatar src={props.bigAvatars ? user.big_avatar : user.avatar} className="avatar" department={user.department} />;
            }
            return (
              <OverlayTrigger key={index} placement="top" overlay={<Tooltip>{user.name}</Tooltip>}>
                <div data-email={userEmail} onClick={(e) => unselectUser(e)} className="d-inline-block cont mr-2 mb-1">
                  {avatar}
                  <div className="overlay" data-email={userEmail}>
                    <i style={{ pointerEvents: "none" }} className="fa fa-times"></i>
                  </div>
                  <input hidden name={fieldsFor} value={userEmail} readOnly />
                </div>
              </OverlayTrigger>
            );
          }
        })}
        <Button
          variant="success"
          className="select-users-button d-inline-block mb-3"
          style={{ verticalAlign: "top" }}
          disabled={btnDisabled}
          onClick={handleShow}>
          <span>+</span>
        </Button>
        <Modal className="users-select-modal" show={show} onHide={handleClose} style={{ zIndex: 3001 }}>
          <div className="page-1">
            <Modal.Header closeButton>
              <Modal.Title>{props.modalHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="user-search">
                    <span className="fa fa-search"></span>
                    <input onChange={(e) => searchUsers(e)} placeholder="Enter a name or email address..." />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <ul className="user-list">
                    {visibleUsers.map((userEmail) => {
                      let user = props.users[userEmail];
                      let avatar = <DefaultAvatar dim="32x32" name={user.name} className="avatar" department={user.department} />;
                      if (user.avatar) {
                        avatar = <CustomAvatar src={user.avatar} className="avatar" department={user.department} />;
                      }
                      let toggled = toggledUsers.includes(userEmail) ? "toggled" : undefined;
                      return (
                        <React.Fragment key={user.id}>
                          <li onClick={(e) => toggleUser(e)} data-email={userEmail} className={toggled}>
                            <div style={{ pointerEvents: "none" }}>
                              <div className="d-inline-block m-0">
                                <div className="position-relative d-inline-block">
                                  {avatar}
                                  <div className="overlay">
                                    <i className="fa fa-check"></i>
                                  </div>
                                </div>
                                <b>&nbsp;{user.name}</b>
                                <span className="user-email">&nbsp;{userEmail}</span>
                              </div>
                            </div>
                          </li>
                        </React.Fragment>
                      );
                    })}
                  </ul>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <div className="toggled-users">
                <p>
                  <b>To be selected:</b>
                </p>
                {toggledUsersList}
              </div>
              <div className="action-buttons">
                <Button style={{ backgroundColor: "#A3A3A3" }} onClick={handleCancel}>
                  Cancel
                </Button>
                <Button variant="success" onClick={selectUsers}>
                  Select users
                </Button>
              </div>
            </Modal.Footer>
          </div>
        </Modal>
      </div>
    </>
  );
}
